import BaseModel from './BaseModel'
import Location from '@/models/Location'

export default class CompanyCountry extends BaseModel {}

CompanyCountry.mapping = {
  location: Location
}
